import React, { useState, useEffect } from 'react';
import '../css/CallForm.css';
import { FaPhoneAlt, FaSearchPlus, FaSearch } from 'react-icons/fa';
import { FaMapMarkerAlt, FaCalendarAlt, FaUser } from 'react-icons/fa';
import Testimonial from '../Components/Testimonial.jsx';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import PGListings from "../Components/PGListings.jsx";
import ProfileCard from '../Components/ProfileCard';

import Amenities from '../Components/Amenities.jsx';
import HeroSlider from '../Components/HeroSlider.jsx';
import Canonical from "../Components/Canonical.jsx";

const CallForm = () => {
  const [checkIn, setCheckIn] = useState(null);
  const [checkOut, setCheckOut] = useState(null);
  const [name, setName] = useState('');
  const [guests, setGuests] = useState('');
 
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
 
  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, phone, message } = formData;
    if (!name || !email || !phone) {
      alert("Please fill all required fields.");
      return;
    }
    const whatsappText = `Hello, I am interested in your PG listings.%0A%0AName: ${name}%0AEmail: ${email}%0APhone: ${phone}%0AMessage: ${message}`;
    const whatsappLink = `https://wa.me/918879779777?text=${whatsappText}`;
    window.open(whatsappLink, '_blank');
  };
 
  const handleSearchSubmit = () => {
    const message = `Name: ${name}\nCheck-In: ${checkIn}\nCheck-Out: ${checkOut}\nGuests: ${guests}`;
    console.log(message);
    const encoded = encodeURIComponent(message);
    window.open(`https://wa.me/918879779777?text=${encoded}`, '_blank');
  };
 
  return (
    <div>
      <Canonical url="https://www.nobrokeragepayingguest.in/" />
      {/* <HeroSlider/> */}
      <div className="call-section">
        <div className="hero-banner">
          <div className="hero-banner-overlay"></div>
          <div className="hero-banner-content">
            <h1>Welcome to<br/> <span className="highlight-text">No Brokerage Paying Guest</span></h1>
            {/* <h2>Powered by <span className="highlight-text">Comfy Stays</span></h2> */}
            <p>Find the best paying guest accommodation with zero brokerage and fully furnished rooms. </p>
            <a href='/contact'><button className="hero-btn-cta">Explore Now</button></a>
          </div>
        </div>
      </div>
      <br />
      <PGListings />
      <div className="secure-hero">
        <div className="secure-hero-dark-overlay"></div>
        <div className="secure-hero-content">
          <h1 className="hero-heading">Hygiene, Safe & Secure Accommodation</h1>
          <div className="hero-buttons">
            <button
              className="hero-btn contact-btn"
              onClick={() => window.location.href = '/contact'}
            >
              Contact With Us
            </button>
          </div>
        </div>
      </div>

      <Amenities/>
      <ProfileCard />
      <Testimonial />
    </div>
  );
};
 
export default CallForm;